import { MonoMenuCacheItem, MonoMenuEntree, MonoMenuEntreeGroup } from '@/models';
import Vue from 'vue';
import { excludedContentGroupsByType, excludedUniversalItemsByCountry, exludedUniversalItems, includedItemsByType, nutritionExceptions } from './mono-menu-constants';

// Mono menu build check to add the included group if an entree has included items
export function addIncludedItemGroup(entreeType: string, groups: any[]): void {
  const includedItems = includedItemsByType[entreeType];
  if (includedItems !== null) {
    groups.push({
      type: 'includedItem',
      title: 'INCLUDED INGREDIENT',
      items: includedItems,
    });
  }
}

// Mono menu build check to remove content groups from the list if we shouldn't be displaying it to the user
export function removeExcludedContentGroups(entreeType: string, groups: any[]): any[] {
  const excludedContentGroups = excludedContentGroupsByType[entreeType];
  if (excludedContentGroups) {
    return groups.filter((group: MonoMenuEntreeGroup) => excludedContentGroups.indexOf(group.title) < 0);
  }

  return groups;
}

export function removeExcludedUniversalItems(monoMenuCacheItems: { [index: string]: MonoMenuCacheItem}) {
  exludedUniversalItems.forEach(i => {
    if (monoMenuCacheItems[i]) {
      Vue.delete(monoMenuCacheItems, i);
    }
  });
}

// Mono menu build check to remove country specific items
export function removeCountrySpecificItems(countryCode: string, monoMenuCacheItems: { [index: string]: MonoMenuCacheItem}){
  const itemsToRemove = excludedUniversalItemsByCountry[countryCode];

  if (itemsToRemove != null) {
    itemsToRemove.forEach(i => {
      if (monoMenuCacheItems[i]) {
        Vue.delete(monoMenuCacheItems, i);
      }
    });
  }
}

export function getNutritionException(itemId: string | undefined, topLevelMenuItemTitle: string | null) {
  return nutritionExceptions.find(n => n.itemId === itemId && n.topLevelMenuTitle === topLevelMenuItemTitle);
}

export function isVeggieEntree(entree: MonoMenuEntree | undefined): boolean {
  const veggieFillingNames = ['Veggie', 'Fajita Veggies', 'Cheese'];

  return veggieFillingNames.indexOf(entree?.primaryFillingName || '') > -1;
}